import { Spinner } from "@chakra-ui/react";
import { FullSizeFlexCentered } from ".";

export const OverlayLoadingSpinner = () => (
    <FullSizeFlexCentered bg="whiteAlpha.700" zIndex="docked">
        <Spinner color="green.600" speed="0.65s" thickness="8px" boxSize={8} />
    </FullSizeFlexCentered>
);
